import React, { useId } from 'react';
import useTranslate from '../../../../hooks/useTranslate';
import useExperience from '../../../../hooks/useExperience';
import { GraySpacerDiv } from '../../../../components/Formatting/StyledComponents';
import { numberOnlyMask } from '../../utils/InputMasks';
import Col from '@digitools/honest-react/dist/lib/components/Col';
import Row from '@digitools/honest-react/dist/lib/components/Row';
import SelectInput from '@digitools/honest-react/dist/lib/components/SelectInput';
import TextInput from '@digitools/honest-react/dist/lib/components/TextInput';
import { NewDateInput } from '@digitools/honest-react';
import RadioGroup from '@digitools/honest-react/dist/lib/components/Radio/RadioGroup';
import Radio from '@digitools/honest-react/dist/lib/components/Radio';
import themes from '@digitools/honest-react/dist/lib/theming/themes';
import Checkbox from '@digitools/honest-react/dist/lib/components/Checkbox';
import { CheckboxGroup } from '@digitools/honest-react';
import { QuestionsText } from '../../i18n/QuestionsText';
import errorMessages from './reflexiveErrorMessages.json';
// TODO: FIXME: SOME OF THESE QUESTIONS ARE OPTIONAL??? HOW AM I SUPPOSED TO KNOW
// example = date of recovery (if applicable) - can't see anything on the payload that indicates if this is optional or not
const AdditionalQuestion = ({ additionalQuestion, applicant, matchingResponse, }) => {
    const { t } = useTranslate();
    const { language } = useExperience();
    const uniqueId = useId();
    // TODO: translate all the static text here (and on Qualifying Questions table too now that i think of it)
    // TODO: add validation functions to all these bad bois
    const errorKey = parseInt(additionalQuestion.questionCode, 10).toString();
    const errorEntry = errorMessages[errorKey];
    const errorMsg = errorEntry ? t(errorEntry) : undefined;
    let field;
    switch (additionalQuestion.responseFormatTypeCode) {
        case 'I':
            field = (<RadioGroup tab-index={0} label='Yes or No' hideLabel={true} isRequired={true} field={'value'} required={true} data-private={true} validateOnChange={true} validateOnBlur={true} initialValue={matchingResponse ? matchingResponse.value[0] : undefined} validate={(value) => !value ? errorMsg : undefined}>
          <Row aria-label={additionalQuestion.text.english}>
            <Radio name={`${additionalQuestion.questionCode} - ${uniqueId}`} label={'Yes'} aria-label={`${additionalQuestion.text.english} - yes`} value={"true"} data-private={true} theme={themes.rebrand} data-testid={additionalQuestion.questionCode + 'yes'} containerStyle={{ marginRight: '1rem' }}/>
            <Radio name={`${additionalQuestion.questionCode} - ${uniqueId}`} label={'No'} aria-label={`${additionalQuestion.text.english} - no`} value={"false"} data-private={true} theme={themes.rebrand} data-testid={additionalQuestion.questionCode + 'no'}/>
          </Row>
        </RadioGroup>);
            break;
        case 'SCD':
            const options = additionalQuestion.responseOptions.map((responseOption) => {
                return ({
                    label: t(responseOption.text),
                    value: responseOption.responseCode
                });
            });
            field = (<SelectInput label={'Select one'} placeholderText={'Select one'} aria-label={`${additionalQuestion.text.english} - select one`} field={'value'} options={options} required={true} validateOnBlur={true} validateOnChange={true} data-private={true} initialValue={matchingResponse ? matchingResponse.value[0] : undefined} theme={themes.rebrand} validate={(value) => !value ? errorMsg : undefined}/>);
            break;
        case 'MCD':
            const multipleOptions = additionalQuestion.responseOptions.map((responseOption) => {
                return ({
                    label: t(responseOption.text),
                    value: responseOption.responseCode
                });
            });
            field = (<CheckboxGroup label={''} hideLabel={true} field={'value'} validate={(values) => !values || values.length < 1 ? (errorMsg ?? t(QuestionsText.reflectiveQuestionValidationError)) : undefined} validateOnChange={true} validateOnBlur={true} data-private={true} required={true} initialValue={matchingResponse ? matchingResponse.value.map((v) => `${applicant}-${v}`) : undefined}>
          {multipleOptions.map((option, i) => {
                    const initialValue = matchingResponse ? matchingResponse.value.indexOf(option.value.toString()) > -1 : undefined;
                    return <Checkbox data-private={true} theme={themes.rebrand} field={`${applicant}-${option.value}`} value={option.value} label={option.label} key={i} initialValue={initialValue} aria-label={`${additionalQuestion.text.english} - ${option.label}`}/>;
                })}
        </CheckboxGroup>);
            break;
        case 'NUM':
            field = (<TextInput label={''} field={'value'} aria-label={additionalQuestion.text.english} mask={numberOnlyMask} required={true} validateOnBlur={true} validateOnChange={true} data-private={true} initialValue={matchingResponse ? matchingResponse.value[0] : undefined} theme={themes.rebrand} validate={(value) => !value ? errorMsg : undefined}/>);
            break;
        case 'DTE':
            field = (<NewDateInput data-testid={'value'} field={'value'} lang={language} label={'Enter date'} aria-label={additionalQuestion.text.english} optional={additionalQuestion.questionCode === '000309'} data-private={true} initialValue={matchingResponse ? matchingResponse.value[0] : undefined} theme={themes.rebrand} validate={(value) => !value && additionalQuestion.questionCode !== '000309' ? errorMsg : undefined}/>);
            break;
        default:
            field = `SOMETHING NEW!!! NOT IMPLEMENTED "${additionalQuestion.questionCode}"`;
            break;
    }
    return (<>
      <div style={{ display: 'none' }} data-private={true}>
        <TextInput hidden={true} data-private={true} hideLabel={true} tabIndex={-1} label={''} field={'questionCode'} initialValue={additionalQuestion.questionCode}/>
      </div>
      <Row style={{ marginBottom: '1rem', }} data-private={true}>
        <Col data-private={true}>{t(additionalQuestion.text)}</Col><Col style={{ flexBasis: '0', flexGrow: '1', maxWidth: '100%' }} aria-label={t(additionalQuestion.text)}>{field}</Col>
      </Row>
      <GraySpacerDiv style={{ height: '1rem', marginBottom: '1rem' }}/>
    </>);
};
export default AdditionalQuestion;
